<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 400px;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox">
      <table>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('glid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属分类
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.glid" placeholder="请选择分类" class="select classification">
                <el-option v-for="(item,index) in classifydata" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('name')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>英文名称
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.name" class="input title" @blur="detection(99, 31, form.title)"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('namec')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>中文名称
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.namec" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('glid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>图层类别
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.maptype" placeholder="请选择分类" class="select classification">
                <el-option v-for="(item,index) in typeData" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2" v-if="form.maptype==='WMS'">
          <td class="td_left">
            <span v-if="isMandatory('url')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>WMS类型URL
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.url" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2" v-if="form.maptype==='WMTS'">
          <td class="td_left">
            <span v-if="isMandatory('geoweburl')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>WMTS类型URL
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.geoweburl" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('layer')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>图层
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.layer" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('showlevel')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>显示级别
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-select clearable v-model="form.showlevel" placeholder="请选择显示级别" class="select classification">
                <el-option v-for="(item,index) in showData" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('filter')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>过滤条件
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.filter" class="input title"></el-input><span style="color: rgb(151, 152, 154);">类似于（"国家"='中国'）填写</span>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>图层图片
          </td>
          <td class="after" style="display: flex;flex-wrap: wrap;align-items: center">
            <el-upload
              v-if="this.$route.path === '/KyxxMap'"
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic"
              :on-change="handleEditChange"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              v-else
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic"
              :file-list="fileList1"
              :on-change="handleEditChange"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width=100% />
            </el-dialog>
            <span style="color: rgb(151, 152, 154);">（96x72）</span>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb2')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>图例
          </td>
          <td class="after">
            <el-upload
              v-if="this.$route.path === '/KyxxMap'"
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic2"
              :on-change="handleEditChange"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess1"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              v-else
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic2"
              :file-list="fileList2"
              :on-change="handleEditChange"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess1"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width=100% />
            </el-dialog>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('filter')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据共享关联id
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.glsjgx" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/KyxxMap'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/KyxxUpdate'">确定</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/KyxxMap'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/KyxxUpdate'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 李旭
 * 矿业信息地图后台添加页
 */
import treeOrder from '../../src/plugins/backer/method/tree.js'
import {mapState} from 'vuex'
export default {
  components: {
  },
  props: ['updataID'],
  data()
  {
    return {
      url: '',
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      fileList1: [{url: ''}],
      fileList2: [{url: ''}],
      form: {
        glid: null,
        name: '',
        namec: '',
        maptype: null,
        url: 'https://www.camining.cn/zgis/mapserver/zgis/wms',
        geoweburl: 'https://www.camining.cn/zgis/mapserver/zgis/gwc/service/wmts',
        layer: '',
        thumb: '',
        legendurl: '',
        showlevel: null,
        filter: '',
        glsjgx: ''
      },
      //所属分类数据
      classifydata: [],
      typeData: [{value: 'WMS', label: 'WMS'}, {value: 'WMTS', label: 'WMTS'}], //图层类型
      showData: [{value: 1, label: '点'}, {value: 2, label: '线'}, {value: 3, label: '面'}], //显示级别类型
      //表名
      tabname: 'wms',
      //fld表数据
      fldData: []
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          this.classifydata = this.classifydata.concat(treeOrder.TreeThree(ret))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    this.getList()
    this.fldData = await window.public.validation(this.tabname)
    this.isgetData()
  },
  methods: {
    //添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 99,
        _minor: 31,
        retAtt: 1,
        glid: this.form.glid ? this.form.glid : 0,
        name: this.form.name,
        namee: this.form.name,
        namec: this.form.namec,
        maptype: this.form.maptype,
        url: this.form.url,
        geoweburl: this.form.geoweburl,
        layer: this.form.layer,
        visible: 1,
        showlevel: this.form.showlevel,
        thumb: this.form.thumb,
        legendurl: this.form.thumb2,
        glsjgx: this.form.glsjgx,
        filter: this.form.filter
      }
      console.log(obj)
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onIsLb', '1')
        }
      })
    },
    getList()
    {
      let paras = {
        cmd: 'query',
        _major: 99,
        _minor: 31,
        _exp: 'id > 0'
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.classifydata = []
        this.classifydata = this.classifydata.concat(treeOrder.TreeThrees(ret))
      })
    },
    //获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/KyxxUpdate')
        this.getData()
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 99,
        _minor: 31,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.glid = ret[0].glid
        this.form.name = ret[0].name
        this.form.namee = ret[0].name
        this.form.namec = ret[0].namec
        this.form.filter = ret[0].filter
        this.form.maptype = ret[0].maptype
        this.form.type = ret[0].type
        this.form.url = ret[0].url
        this.form.layer = ret[0].layer
        this.form.showlevel = ret[0].showlevel
        this.form.geoweburl = ret[0].geoweburl
        this.fileList1[0].url = ret[0].thumb
        this.fileList2[0].url = ret[0].legendurl
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 99,
        _minor: 31,
        retAtt: 1,
        id: this.form.id,
        glid: this.form.glid ? this.form.glid : 0,
        name: this.form.name,
        namee: this.form.name,
        namec: this.form.namec,
        maptype: this.form.maptype,
        url: this.form.url,
        geoweburl: this.form.geoweburl,
        layer: this.form.layer,
        visible: 1,
        showlevel: this.form.showlevel,
        thumb: this.form.thumb,
        legendurl: this.form.thumb2,
        glsjgx: this.form.glsjgx,
        filter: this.form.filter
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/KyxxMap'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/KyxxMap'})
      this.$store.commit('onActiveName', '1')
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    // 上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    onSuccess1(response)
    {
      let that = this
      window.public.onSuccess1(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/KyxxAdd.vue